export const GET_ROLES_PAGINATION = 'GET_ROLES_PAGINATION';
export const GET_ROLES = 'GET_ROLES';
export const CHANGE_PARAMS = 'change_users_params';
export const ADD_USER_ROLE = 'add_user_role';
export const SELECT_USER_ROLE = 'selected_user_role';
export const SET_PAGE_ACTIONS = 'set_page_actions';
